"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DataAccessor {
    constructor(getter, setter) {
        this.getter = getter;
        this.setter = setter;
    }
    setString(context, key, value) {
        this.setter(context, key, value);
    }
    getString(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new Error('DataAccessor: Missing value for key: ' + key);
        }
        return data;
    }
    getStringOrNull(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        return data;
    }
    setInt(context, key, value) {
        this.setter(context, key, value === undefined ? value : value.toString());
    }
    getInt(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new Error('DataAccessor: Missing value for key: ' + key);
        }
        const intValue = parseInt(data);
        if (DataAccessor.INT_REGEX.test(data) === false || isNaN(intValue)) {
            throw new Error('DataAccessor: Value isn\'t int value: ' + data);
        }
        return intValue;
    }
    getIntOrNull(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        const intValue = parseInt(data);
        if (DataAccessor.INT_REGEX.test(data) === false || isNaN(intValue)) {
            return null;
        }
        return intValue;
    }
    setFloat(context, key, value) {
        this.setter(context, key, value === undefined ? value : value.toString());
    }
    getFloat(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new Error('DataAccessor: Missing value for key: ' + key);
        }
        const floatValue = parseFloat(data);
        if (DataAccessor.FLOAT_REGEX.test(data) === false || isNaN(floatValue)) {
            throw new Error('DataAccessor: Value isn\'t float value: ' + data);
        }
        return floatValue;
    }
    getFloatOrNull(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        const floatValue = parseFloat(data);
        if (DataAccessor.FLOAT_REGEX.test(data) === false || isNaN(floatValue)) {
            return null;
        }
        return floatValue;
    }
    setDate(context, key, value) {
        this.setter(context, key, value.toString());
    }
    getDate(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new Error('DataAccessor: Missing value for key: ' + key);
        }
        const dateValue = new Date(data);
        if (isNaN(dateValue.getTime())) {
            throw new Error('DataAccessor: Value isn\'t date value: ' + data);
        }
        return dateValue;
    }
    getDateOrNull(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        const dateValue = new Date(data);
        if (isNaN(dateValue.getTime())) {
            return null;
        }
        return dateValue;
    }
    setJson(context, key, value) {
        this.setter(context, key, value === undefined ? value : JSON.stringify(value));
    }
    getJson(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            throw new Error('DataAccessor: Missing value for key: ' + key);
        }
        try {
            return JSON.parse(data);
            // intentionally catch all exceptions to allow default value to support recovery
            // eslint-disable-next-line @typescript-eslint/no-implicit-any-catch
        }
        catch (e) {
            if (defaultValue !== undefined) {
                return defaultValue;
            }
            throw e;
        }
    }
    getJsonOrNull(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return null;
        }
        try {
            return JSON.parse(data);
            // intentionally catch all exceptions to allow default value to support recovery
            // eslint-disable-next-line @typescript-eslint/no-implicit-any-catch
        }
        catch (e) {
            if (defaultValue !== undefined) {
                return defaultValue;
            }
            return null;
        }
    }
    getBool(context, key, defaultValue) {
        const data = this.getter(context, key);
        if (data === undefined && defaultValue !== undefined) {
            return defaultValue;
        }
        if (data === undefined) {
            return false;
        }
        return data.toLowerCase() !== 'false' && data !== '0';
    }
    setBool(context, key, value) {
        this.setter(context, key, value.toString());
    }
    has(context, key) {
        return this.getter(context, key) !== undefined;
    }
}
DataAccessor.INT_REGEX = new RegExp(/^-?\d+$/);
DataAccessor.FLOAT_REGEX = new RegExp(/^-?\d+(?:\.\d+)?$/);
exports.default = DataAccessor;
//# sourceMappingURL=DataAccessor.js.map